import { Component, input, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { SkeletonModule } from 'primeng/skeleton';
import { Agent } from '@models/agent.types';
import { DurationPipe } from '@app/pipes/duration.pipe';
import { TimeAgoPipe } from '@app/pipes/time-ago.pipe';

@Component({
  selector: 'app-agent-status-widget',
  standalone: true,
  imports: [CommonModule, CardModule, TagModule, SkeletonModule, DurationPipe, TimeAgoPipe],
  templateUrl: './agent-status-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentStatusWidget {
  constructor() {
    console.log('AgentStatusWidget initialized');
  }
  agents = input<Agent[]>([]);
  loading = input<boolean>(false);

  getStatusColor(isOnline: boolean | undefined): string {
    return isOnline ? 'bg-green-500' : 'bg-gray-500';
  }

  onlineAgents = computed(() => this.agents().filter(agent => agent.is_online));
  offlineAgents = computed(() => this.agents().filter(agent => !agent.is_online));

  showOffline = signal(false);

  toggleOffline() {
    this.showOffline.update(v => !v);
  }
}
